const ModeOperation = Object.freeze({
    /*
     * IDE-based debugging.
     * Simulate server to board communication (over MQTT).
     *
     * App: WebStorm built-in webserver
     * Data: mosquitto MQTT
     */
    DEBUG_APP: Symbol("debug"),

    /*
     * Production!
     * Need "run build" to generate production folder
     *
     * App: Nginx + FastAPI
     * Data: MQTT
     */
    PRODUCTION_APP: Symbol("production"),
});

/*
 * Configurations
 */
const app_version = [2, 3, 0]
const build_date = "Bilbao, build on Oct 30 2025"
const modeOperation = ModeOperation.PRODUCTION_APP;


function get_remote_api() {
    if (modeOperation === ModeOperation.PRODUCTION_APP) {
        // Production. URL of the server running Nginx + FastAPI
        return "https://api.altrabits.com"
    } else if (modeOperation === ModeOperation.DEBUG_APP) {
        // Development. Pycharm-based FastAPI server
        //return "http://localhost:8000"
        //return "http://192.168.1.20:8000" // Nano
        //return "http://192.168.1.40:8000" // My computer
        return "http://192.168.1.120:8000" // My computer
    }
}


function is_debug_mode() {
    if (modeOperation === ModeOperation.DEBUG_APP) {
        return true
    } else if (modeOperation === ModeOperation.PRODUCTION_APP) {
        return false
    }
}


function get_app_name() {
    switch (modeOperation) {
        case ModeOperation.DEBUG_APP:
            return "AltraBits App (DEBUG)"

        case ModeOperation.PRODUCTION_APP:
            return "AltraBits App"
    }
}

function get_app_version_string() {
    return app_version.join('.') + " - " + build_date
}


function get_public_media(path, useSize = "medium", theme = false, disableCache = false) {

    if (path) {
        //const color = typeof theme === "boolean" ? theme ? "black" : "white" : theme
        const size = useSize == null ? "medium" : useSize
        const cache = disableCache ? "?nocache=" + Date.now() : ""

        // E.g., /public/media/small-black-e3420664-ec2c-403f-a711-dd5f5c2fd13f.jpg?nocache=1741607560800
        //return get_remote_api() + "/public/media/" + size + "-" + color + "-" + path + cache
        return get_remote_api() + "/public/media/" + size + "-" + path + cache
    }
    return null

}

export const config = {
    get_remote_api,
    is_debug_mode,
    get_app_name,
    get_app_version_string,
    get_public_media
};

